import type { ExportConfig, GeneratedFile, LanguageGenerator } from './types';
import { generateEnv } from './utils';

export const shellGenerator: LanguageGenerator = {
  id: 'shell',
  name: 'Shell (curl)',
  category: 'request-examples',
  color: '#4EAA25',
  generate(config: ExportConfig): GeneratedFile[] {
    const lines: string[] = [
      '#!/usr/bin/env bash',
      '# mail_requests.sh — generated by Mail Service SDK Export',
      '# Load your .env before running: source .env',
      '',
      `SERVICE_URL="\${${config.serviceUrlVarName}}"`,
      '',
    ];

    for (const app of config.apps) {
      lines.push(`# ── ${app.name} ──────────────────────────────────────`);
      lines.push(`${app.envVarName}="\${${app.envVarName}}"`);
      lines.push('');
      for (const t of app.templates) {
        const schemaComment = t.schema
          ? t.schema.map((f) => `#   ${f.key}: "${f.example || f.type}"`).join('\n')
          : '#   (no schema defined)';
        const exampleData = t.schema
          ? `{${t.schema.map((f) => `"${f.key}": ${f.type === 'number' ? (f.example || '0') : f.type === 'boolean' ? 'true' : `"${f.example || f.key}"`}`).join(', ')}}`
          : '{}';
        lines.push(`# Send: ${t.name}`);
        lines.push(`# Payload fields:`);
        lines.push(schemaComment);
        lines.push(`curl -s -X POST "$SERVICE_URL/v1/send" \\`);
        lines.push(`  -H "Content-Type: application/json" \\`);
        lines.push(`  -H "X-API-KEY: $${app.envVarName}" \\`);
        lines.push(`  -d '{"template_slug": "${t.slug}", "recipient": "user@example.com", "data": ${exampleData}}'`);
        lines.push('');
      }
    }

    return [
      { filename: 'mail_requests.sh', content: lines.join('\n'), syntax: 'shell' },
      { filename: '.env', content: generateEnv(config), syntax: 'shell' },
    ];
  },
};
